import { render, staticRenderFns } from "./LihatSemua.vue?vue&type=template&id=4ba33a74"
import script from "./LihatSemua.vue?vue&type=script&lang=js"
export * from "./LihatSemua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports